"use client";

import { useEffect } from "react";

export function DragDropGuard() {
  useEffect(() => {
    const swallow = (e: DragEvent) => {
      // If any drop zone upstream called preventDefault() on dragover,
      // the browser considers it a valid drop target — let the event through.
      // Otherwise the WebView2 host can get stuck on unhandled drags, so we cancel.
      if (e.defaultPrevented) return;
      e.preventDefault();
    };
    window.addEventListener("dragover", swallow);
    window.addEventListener("drop", swallow);
    return () => {
      window.removeEventListener("dragover", swallow);
      window.removeEventListener("drop", swallow);
    };
  }, []);

  return null;
}
